<template>
  <div style="padding-bottom:70px">
    <van-nav-bar 
    style=";width:100%"  
    left-text="返回"
    left-arrow
    @click-left="goToList">
      <template #title>
        <span>{{title}}</span>
      </template>
    </van-nav-bar>

    <div  class="baseInfo">
      <van-cell-group>
      <van-cell>
        <div class="goods-title">
          <van-col span="21" style="font-weight:700">工单明细【<span style="text-align:right;padding-left:4px;font-size:16px;color:#1989fa;font-weight:700">{{  baseInfo&&baseInfo.woId }}</span>】</van-col>
          <van-col span="3" style="font-weight:700"><van-icon name="description" size="24" @click="viewFileAttacth"  color="#ff976a" style="font-size:24px;float:right"/></van-col>
        </div>
      </van-cell>
      <van-cell class="goods-express" >
        <div class="wrapper">
        <van-col span="12"><span class="detailTitle">品号:</span> <span class="detailContent">{{baseInfo&&baseInfo.productNo }}</span></van-col>
        <van-col span="12"><span class="detailTitle">单位:</span> <span class="detailContent">{{baseInfo&&baseInfo.unit }}</span></van-col>
        <van-col span="12"><span class="detailTitle">预计开工:</span> <span class="detailContent">{{baseInfo&&baseInfo.startDate }}</span></van-col>
        <van-col span="12"><span class="detailTitle">预计完工:</span> <span class="detailContent">{{baseInfo&&baseInfo.endDate }}</span></van-col>
       
        <van-col span="12"><span class="detailTitle">批号:</span> <span class="detailContent" >{{ baseInfo&&baseInfo.batchId }}</span></van-col>
        <van-col span="12"><span class="detailTitle">订单号:</span> <span class="detailContent" >{{ baseInfo&&baseInfo.orderId }}</span></van-col>
        <van-col span="24"><span class="detailTitle">品名:</span> <span class="detailContent">{{baseInfo&&baseInfo.productName }}</span></van-col>
        <van-col span="24"><span class="detailTitle">规格:</span> <span class="detailContent">{{ baseInfo&&baseInfo.spec }}</span></van-col>
        <van-col span="24"><span class="detailTitle">采购商:</span> <span class="detailContent">{{baseInfo&&baseInfo.clientName }}</span></van-col>
        <van-col span="24"><span class="detailTitle">备注:</span> <span class="detailContent">{{baseInfo&&formateBack(baseInfo.back) }}</span></van-col>
      </div>
      </van-cell>
    </van-cell-group>
    </div>

    <div class="list" v-if="woId&&isFeeding">
      <van-tabs v-model:active="activeList">
        <van-tab title="正常工序">
          <vxe-table
            ref="xTable"
            size="small"
            round
            :height="tableHeight"
            :align="allAlign"  
            @radio-change="changeRadio"
            stripe
            border
            :row-class-name="rowClassName"
            :scroll-y="{enabled: false}"
            :data="tableData">
            <vxe-column type="radio" width="30" ></vxe-column>
            <vxe-column field="woIndex" title="序号" width="50"></vxe-column>
            <vxe-column field="department" title="车间" width="72"></vxe-column>
            <vxe-column field="workmanshipName" title="工艺" width="72"></vxe-column>
            <vxe-column field="count" title="应报" width="60"></vxe-column>
            <vxe-column field="finishCount" title="已报" width="60"></vxe-column>
            <vxe-column field="failedCount" title="废弃" width="60"></vxe-column>
            <vxe-column field="productor" title="工人" width="60"></vxe-column>
          </vxe-table>
        </van-tab>
        <van-tab title="返工工序">
            <vxe-table
              ref="xRedoTable"
              border
              stripe
              size="small"
              :height="tableHeight"
              :align="allAlign"
              :data="redoTableData">
              <vxe-column field="woIndex" title="序号" width="50"></vxe-column>
              <vxe-column field="department" title="车间" width="72"></vxe-column>
              <vxe-column field="workmanshipName" title="工艺" width="72"></vxe-column>
              <vxe-column field="finishCount" title="已报" width="60"></vxe-column>
              <vxe-column field="failedCount" title="废弃" width="60"></vxe-column>
              <vxe-column field="time" title="时间" width="160"></vxe-column>
              <vxe-column field="productor" title="工人" width="60"></vxe-column>
            </vxe-table>
          </van-tab>
      </van-tabs>
        
    </div>
    <div  v-if="woId&&!isFeeding&&loadDetail" style="text-align:center;margin-top:40px;">
      <van-empty description="该产品尚未投料!"/>
    </div>

    <div style="position:fixed;width:100%;bottom:0px;height:50px;background-color:#fff;line-height:40px;z-index:999">
        <van-row style="text-align:center">
          <van-col span="12" ><van-button type="warning" icon="ok"  style="width:120px"  @click="showReportListDialog" size="small" >{{isUserChecker?'质检':'报工详情'}}</van-button></van-col>
          <van-col span="12" ><van-button type="primary" icon="ok"  style="width:120px" @click="showReportDialog" size="small" :disabled="woStatus != 'N' || isBatchCompleted || isUserChecker">报工</van-button></van-col>
        </van-row>
    </div>

    <van-popup v-model ="redoDialogVisable" position="bottom" style="max-height:80%;padding-bottom:20px">
      <van-cell v-for="(reportData,index) in selectedReportDetailList" :key="index" title="" >
            <template #label>
              <van-row style="padding:8px">
                <div>
                  <van-col span="4" style="margin-top:5px;">
                    <div style="background-color:#1989fa;color:white;border-radius:10px;width:32px;">
                        <van-row style="height:32px;line-height:32px;text-align:center;font-size:20px;">{{index+1}}</van-row>
                    </div>
                  </van-col>
                  <van-col span="20">
                    <van-row>
                      <div class="wrapper1"> 
                        <van-col span="24" style="margin-top:12px;">
                          <span class="reportDetailContent" style="font-size:20px;font-weight:700">{{reportData.productor}}</span>
                        </van-col>
                      
                        <van-col span="24" style="margin-top:12px"><span class="reportDetailTitle">报工时间:</span> <span class="reportDetailContent">{{reportData.time}}</span></van-col>
                        <van-col span="12"><span class="reportDetailTitle">已报: </span> <span class="reportDetailContent">{{reportData.finishCount}}</span></van-col>
                        <van-col span="12"><span class="reportDetailTitle">废弃:</span> <span class="reportDetailContent">{{reportData.failedCount}}</span></van-col>     
                        <van-col span="12"><span class="reportDetailTitle">{{submitWorkOrderParamsName.param1}}:</span> <span class="reportDetailContent">{{reportData.param1}}</span></van-col>
                        <van-col span="12"><span class="reportDetailTitle">{{submitWorkOrderParamsName.param2}}:</span> <span class="reportDetailContent">{{reportData.param2}}</span></van-col>
                        <van-col span="12"><span class="reportDetailTitle">{{submitWorkOrderParamsName.param3}}:</span> <span class="reportDetailContent">{{reportData.param3}}</span></van-col>
                        <van-col span="12"><span class="reportDetailTitle">{{submitWorkOrderParamsName.param6}}:</span> <span class="reportDetailContent">{{reportData.param6}}</span></van-col>
                        <van-col span="12"><span class="reportDetailTitle">{{submitWorkOrderParamsName.param4}}:</span> <span class="reportDetailContent">{{reportData.param4}}</span></van-col>
                        <van-col span="24"><span class="reportDetailTitle">{{submitWorkOrderParamsName.param5}}:</span> <span class="reportDetailContent">{{reportData.param5}}</span></van-col>
                        
                        <van-col span="24" style="margin-top:-6px;">
                          <van-row >
                            <van-col span="10" style="line-height:28px;margin-top:2px;">
                              <span class="reportDetailTitle" style="width:96px !important">质检不良数:</span> 
                            </van-col>

                            <van-col span="14" style="margin-left:-6px">
                              <span class="reportDetailContent" style="color:Red;line-height:28px;margin-top:-6px;" v-if="!reportData.beginReportCheck">{{reportData.checkFailedCount}}</span>
                              <van-field
                                v-model="reportData.checkFailedCount"
                                type="number" 
                                v-if="reportData.beginReportCheck"
                                style="padding:0px;margin:0px;color:red;margin-top:-1px;"
                              />
                            </van-col>
                          </van-row>
                        </van-col>

                        <van-col span="24" style="margin-top:-15px;">
                          <van-row>
                            <van-col span="8">
                              <span class="reportDetailTitle" style="margin-top:3px;">质检说明:</span> 
                            </van-col>

                            <van-col span="16">
                              <span class="reportDetailContent" style="color:Red;width:100%;" v-if="!reportData.beginReportCheck">{{reportData.checkDescription}}</span>
                              <van-field
                                v-model="reportData.checkDescription"
                                type="textarea" 
                                rows="4"
                                maxlength="50"
                                show-word-limit
                                v-if="reportData.beginReportCheck"
                                style="padding:0px;margin:0px;color:red"
                              />
                            </van-col>
                          </van-row>
                        </van-col>

                        <van-col span="24" style="margin-top:-10px;">
                          <van-row>
                            <van-col span="8">
                              <span class="reportDetailTitle" style="margin-top:3px;">质检图片:</span> 
                            </van-col>

                            <van-col span="16">
                              <van-icon name="live" @click="checkPhoto(reportData)" size="24" v-if="isUserChecker"/>
                            </van-col>

                            <van-col span="24">
                              <template v-if="reportData.images&&reportData.images!=''">
                              
                                <template v-for="(image,index) in reportData.images">
                                  <!--<span style="width:240px;display:inline-block;word-break:break-word">{{image}}</span>-->
                                  <van-image
                                    :src="image"
                                    :class="reportData.isFullScring?'imageFullScring':'imageNormal'"
                                    @click="o=> reportData.isFullScring = reportData.isFullScring?!reportData.isFullScring:'true'"
                                    :key="index"
                                  />
                                </template>
                              </template>
                            </van-col>
                          </van-row>
                        </van-col>

                        <van-col span="24"  style="margin-top:2px;">
                          <span class="reportDetailTitle">状态:</span> <span class="reportDetailContent"><span v-if="reportData.isAudit == 'T'" style="color:dodgerblue">已审核</span>
                          <span v-else>未审核</span></span>
                        </van-col>
                      </div>

                      <van-col span="24" style="margin-top:10px;">
                        <van-button size="mini" type="warning" icon="ok"    style="float:right;margin-right:20px;width:80px"  @click="redo(reportData)" v-if="!isUserChecker && reportData.productorNo == userNo && woStatus == 'N'">返工{{ reportData.name }}</van-button>
                        <van-button  size="mini" type="primary"  icon="ok"  style="float:right;margin-right:20px;width:80px;" @click="audit(reportData)" v-if="!isUserChecker && reportData.isAudit != 'T'">审核</van-button>
                        <van-button  size="mini" type="primary"  icon="ok"  style="float:right;margin-right:20px;width:80px;" @click="o=> {reportData.beginReportCheck = true;$forceUpdate();}" v-if="isUserChecker&&!reportData.beginReportCheck">质检填报</van-button>
                        
                        <van-button  size="mini" type="primary"  icon="ok"  style="float:right;margin-right:20px;width:80px;" @click="finishCheckReport(reportData,index)" v-if="isUserChecker&&reportData.beginReportCheck">提交</van-button>
                      </van-col>
                      
                    </van-row>
                  </van-col>
                  
                </div>
              </van-row>
            </template>
        </van-cell>
        <!--<vxe-table
          ref="xRedoTable"
          border
          size="small"
          height="400"
          :align="allAlign"
          stripe
          :data="selectedReportDetailList">
          <vxe-column field="productor" title="工人" width="60"></vxe-column>
          <vxe-column field="finishCount" title="已报" width="60">
          </vxe-column>
          <vxe-column field="failedCount" title="废弃" width="60"></vxe-column>
          <vxe-column field="param1" :title="submitWorkOrderParamsName.param1" width="80"></vxe-column>
          <vxe-column field="param2" :title="submitWorkOrderParamsName.param2" width="80"></vxe-column>
          <vxe-column field="param3" :title="submitWorkOrderParamsName.param3" width="80"></vxe-column>
          <vxe-column field="param4" :title="submitWorkOrderParamsName.param4" width="80"></vxe-column>
          <vxe-column field="param5" :title="submitWorkOrderParamsName.param5" width="80"></vxe-column>
          
          <vxe-column field="isAudit" title="状态" width="80">
            <template #default="{ row }">
              <span v-if="row.isAudit == 'T'" style="color:dodgerblue">已审核</span>
              <span v-else>未审核</span>
            </template>
          </vxe-column>
          <vxe-column field="time" title="日期" width="160"></vxe-column>
          <vxe-column  field="operator" title="操作"  :resizable="false" show-overflow width="160">
            <template #default="{ row }">
              <vxe-button  size="mini" @click="redo(row)" v-if="row.productorNo == userNo && woStatus == 'N'">返工{{ row.name }}</vxe-button>
              <vxe-button  size="mini" @click="audit(row)" v-if="row.isAudit != 'T'">审核</vxe-button>
            </template>
          </vxe-column>
          
        </vxe-table>-->
    </van-popup>

    <van-popup v-model ="reportDialogVisable" position="bottom">
      <van-form>
        <van-cell-group inset>
          <van-field
              v-model="reportParmas.nextWorkManShip.displayWorkManShipName"
              name="下道工序"
              label="下道工序"
              placeholder=""
              disabled
              clearable
              v-if="reportParmas.nextWorkManShip"
            >
            <template #button>
              <van-icon  name="descending" size="20"   @click="$refs.workmanshipSelectDialog.open(nextWorkmanshipList,isNextWorkManshipJumpEnable)" style="font-size:20px"/>
            </template>
          </van-field>

          <van-field
                v-model="reportParmas.store.name"
                name="仓库"
                label="仓库"
                placeholder=""
                disabled
                clearable
                v-if="nextWorkmanshipList.length == 0 "
              >
                <template #button>
                  <van-icon name="delete" size="24" @click="()=> { reportParmas.store = { id:'', name:'' }}" style="font-size:24px"/>
                  <van-icon name="search" size="24" @click="$refs.storeSelectDialog.open()" style="font-size:24px;margin-left:4px;"/>
                </template>
              </van-field>

              <StoresSelectDialog
                isSingle = true
                propsFilter = "1"
                ref="storeSelectDialog"
                @select="
                  (data) => {
                    reportParmas.store = data;
                    $forceUpdate();
                  }
                "
              ></StoresSelectDialog>

          <van-field
            v-model="reportParmas.finishCount"
            name="报工数"
            label="报工数"
            type="number" 
            placeholder="报工数"
            
          />
          <!--:rules="[{ required: true, message: '请填写报工数' },{ validator:(val)=> {return val >0} , message: '报工数应大于0' }]"-->
          <van-field
            v-model="reportParmas.failedCount"
            name="报废数量"
            label="报废数量"
            type="number" 
            disabled
            placeholder="报废数量"
            :rules="[{ required: true, message: '请填写报废数量' }]"
          />
          <van-field
            v-model="reportParmas.gFailedCount"
            :name="submitWorkOrderParamsName.param1"
            :label="submitWorkOrderParamsName.param1"
            type="number" 
            placeholder=""
            @blur="reportParmas.failedCount = parseFloat(reportParmas.gFailedCount)+parseFloat(reportParmas.lFailedCount)+parseFloat(reportParmas.djFailedCount)"
          />
          <van-field
            v-model="reportParmas.lFailedCount"
            :name="submitWorkOrderParamsName.param2"
            :label="submitWorkOrderParamsName.param2"
            type="number" 
            placeholder="报废数2"
            @blur="reportParmas.failedCount = parseFloat(reportParmas.gFailedCount)+parseFloat(reportParmas.lFailedCount)+parseFloat(reportParmas.djFailedCount)"
            :rules="[{ required: true, message: '请填写报废数2' }]"
          />
          <van-field
            v-model="reportParmas.djFailedCount"
            :name="submitWorkOrderParamsName.param3"
            :label="submitWorkOrderParamsName.param3"
            type="number" 
            placeholder="报废数3"
            @blur="reportParmas.failedCount = parseFloat(reportParmas.gFailedCount)+parseFloat(reportParmas.lFailedCount)+parseFloat(reportParmas.djFailedCount)"
            :rules="[{ required: true, message: '请填写报废数3' }]"
          />
          <van-field
            v-model="reportParmas.otherFailedCount"
            :name="submitWorkOrderParamsName.param6"
            :label="submitWorkOrderParamsName.param6"
            type="number" 
            placeholder="报废数6"
            :rules="[{ required: true, message: '请填写报废数6' }]"
          />
          <van-field
            v-model="reportParmas.assistCount"
            :name="submitWorkOrderParamsName.param4"
            :label="submitWorkOrderParamsName.param4"
            type="number" 
            placeholder="辅助数量"
            :rules="[{ required: true, message: '请填写辅助数量' }]"
          />
          <van-field
            v-model="reportParmas.assistTips"
            :name="submitWorkOrderParamsName.param5"
            :label="submitWorkOrderParamsName.param5"
            type="textarea" 
            placeholder="辅助说明"
            rows="4"
            maxlength="50"
            show-word-limit
          />
        </van-cell-group>
        
        <div style="margin: 16px;">
          <van-button round block type="primary" native-type="submit" @click="finish">
            提交
          </van-button>
        </div>
      </van-form>
    </van-popup>
    
    <van-popup v-model ="attachFilesDialogVisable" position="bottom">
      <van-form>
        <van-grid :border="false" :column-num="2">
          <van-grid-item :key="attach.fileName" v-for="attach in productAttachList">
            <van-image
              src="/attach.jpg"
              style="width:64px"
              @click="download(attach)"
            />
            <a href="javascript:void(0)" style="color:darkgoldenrod" @click="download(attach)">{{ attach.fileName }}{{ attach.fileType }}</a>
          </van-grid-item>
        </van-grid>
      </van-form>
    </van-popup>

    <WorkmanshipSelectDialog
    isSingle = true
      ref="workmanshipSelectDialog"
      @select="
        (data) => {
          updateWorkManShip(data);
          $forceUpdate();
        }
      "
    ></WorkmanshipSelectDialog>

    
  </div>
</template>

<script>
import dateUtil from "../../../util/dateTimeUtil";
import { mapState } from 'vuex'
import Vue from 'vue';
import { Tabbar,TabbarItem,Icon,Button,Col,Toast,Dialog,Tab, Tabs} from 'vant';

import { getSubWoDetail ,doNotLastWork,doLastWork,redo,getProductsAttachList,getProductAttach,auditReport,finishReportCheck,uploadCheckImages  } from '../../../api/wo'
import { getUserDetail } from '../../../api/users'
import store from '../../../store/index'

Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Col);
Vue.use(Dialog);
Vue.use(Tab);
Vue.use(Tabs);

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

Vue.use(VXETable)
let cnNumberArray = ["日","一", "二", "三", "四", "五", "六"];

export default {
  components: {
    Tabbar, 
    TabbarItem,
    Icon,
    Button,
    Col,
    Toast,
    Dialog,
    Tabs,
    Tab
  },
  computed: {
    tableHeight(){
      return Math.max(window.innerHeight - 400,340);
    }
  },
  data() {
    return {
      nextWorkmanshipList:[],
      curDate: "",
      curTime: "",
      loadDetail:false,
      userNo:'',
      curWeekDay: cnNumberArray[new Date().getDay()],
      userName:'',
      scanData:null,
      allAlign: 'center',
      woId:null,
      woStatus:null,
      tableData: [],
      redoTableData:[],
      reportDetailList:[],
      selectedReportDetailList:[],
      title:'MES助手',
      baseInfo:null,
      startTime:null,
      finishTime:null,
      overDepartment:false,
      isFeeding:false,
      qrInfo:null,
      resp:'',
      isNextWorkManshipJumpEnable:false,
      isInRep:false,
      isFinishVisable:false,
      isRedoVisable:false,
      isSubmitting:false,
      isUserChecker:false,
      departmentId:'',
      departmentName:'',
      activeList:0,
      beginReportCheck:true,
      curReportCheckIndex:-1,
      redoDialogVisable:false,
      reportParmas:{
        nextWorkManShip:null,
        failedCount:0,
        finishCount:0,
        assistCount:0,
        gFailedCount:0,
        lFailedCount:0,
        djFailedCount:0,
        otherFailedCount:0,
        assistTips:'',
        store:{
          id:null,
          name:null
        }
      },
      defaultStore:null,
      isBatchCompleted:false,
      reportDialogVisable:false,
      allowOverReport:true,
      attachFilesDialogVisable:false,
      productAttachList:[],
      submitWorkOrderParamsName: {
        param1: "", //报废数量1
        param2: "", //报废数量2
        param3: "", //报废数量3
        param4: "", //辅助数量
        param5: "" //辅助说明
      }
    };
  },
  async mounted(){
    let that = this;
    this.userNo = store.state.authorize.user.userNo;
    this.userName = store.state.authorize.user.userName;


    getUserDetail(this.userNo).then(res=>{
      that.departmentId = res.data.departmentId;
      that.departmentName = res.data.departmentName;
      that.overDepartment = res.data.overDepartment;
    });
  },
  methods: {

    rowClassName ({ rowIndex }) {
      var r = this.tableData[rowIndex];
      return r.count>0&&(r.count - r.failedCount - r.finishCount)<=0?'overReport':'notOverReport'

    },
    updateWorkManShip(data){
      this.reportParmas.nextWorkManShip = data;
      this.reportParmas.nextWorkManShip.displayWorkManShipName = "【"+ this.reportParmas.nextWorkManShip.woIndex +"】" + this.reportParmas.nextWorkManShip.workmanshipName;
    },
    showCheckboxkMethod({ row }){
      return !row.productor&&!this.isInRep;
    },
    showReportDialog(){
      var r = this.$refs.xTable.getRadioRecord(); 

      if(!r){
        Toast('请选中一个工序报工!');
        return;
      }

      /*
      if((r.departmentId != this.departmentId)&&!(this.overDepartment&&r.departmentId.toString().startsWith(this.departmentId))&&!r.isCurWorkmanshipOutsourcing ){
        Toast('非当前工序加工车间!');
        return;
      }*/

      this.reportParmas = {
        failedCount:0,
        nextWorkManShip:null,
        finishCount:Math.max(r.count - r.finishCount - r.failedCount,0),
        maxAllowCount:Math.max(r.count - r.finishCount - r.failedCount,0),
        count:r.count,
        assistCount:0,
        assistTips:'',
        gFailedCount:0,
        lFailedCount:0,
        djFailedCount:0,
        otherFailedCount:0,
        store:{
          id:this.baseInfo.defaultStore,
          name:this.baseInfo.defaultStoreName
        }
      };

      //算出最后一道工序
      var maxWorkManShipWorkIndex = this.tableData[this.tableData.length-1].woIndex;
      //算出第一道工序
      var firstWorkManShipWorkIndex = this.tableData[0].woIndex;
      //算出下道工序
      
      var nextWorkmanships =  this.tableData.filter(o=> o.woIndex!=r.woIndex && o.woIndex !=firstWorkManShipWorkIndex);

      if(nextWorkmanships.length > 0 && r.woIndex != maxWorkManShipWorkIndex){
        //this.reportParmas.nextWorkManShip = nextWorkmanship[0];
        this.nextWorkmanshipList = nextWorkmanships;
      }
      else{
        //this.reportParmas.nextWorkManShip = null;
        this.nextWorkmanshipList = [];
      }

      var nextWorkmanship = this.tableData.filter(o=> parseInt(o.woIndex) > (r.woIndex) );

      if(nextWorkmanships.length > 0 && r.woIndex != maxWorkManShipWorkIndex){
        this.reportParmas.nextWorkManShip = nextWorkmanship[0];
        this.reportParmas.nextWorkManShip.displayWorkManShipName = "【"+ this.reportParmas.nextWorkManShip.woIndex +"】" + this.reportParmas.nextWorkManShip.workmanshipName;
      }
      else{
        this.reportParmas.nextWorkManShip = null;
    
      }

      this.reportDialogVisable = true;
      this.$forceUpdate();
    },
    
    async finish(){
      try
      {
        this.reportParmas.finishCount = parseFloat(this.reportParmas.finishCount);
        this.reportParmas.gFailedCount = parseFloat(this.reportParmas.gFailedCount);
        this.reportParmas.lFailedCount = parseFloat(this.reportParmas.lFailedCount);
        this.reportParmas.djFailedCount = parseFloat(this.reportParmas.djFailedCount);
        this.reportParmas.otherFailedCount = parseFloat(this.reportParmas.otherFailedCount);
        this.reportParmas.maxAllowCount = parseFloat(this.reportParmas.maxAllowCount);
      }
      catch(e){
        console.log('parse float err:');
        console.log(e);
      }



      if(parseInt(this.reportParmas.finishCount) <0 ||
        this.reportParmas.gFailedCount <0 ||
         this.reportParmas.lFailedCount <0 ||
         this.reportParmas.djFailedCount <0){
        Toast('报工数应大于0!');
        return;
      }


      if(!this.allowOverReport){
        if((parseInt(this.reportParmas.finishCount) + parseInt(this.reportParmas.failedCount)) > this.reportParmas.maxAllowCount){
          Toast('不允许超报!');
         return;
        }
      }


      if(this.reportParmas.finishCount == 0 && 
         this.reportParmas.gFailedCount ==0 &&
         this.reportParmas.lFailedCount ==0 &&
         this.reportParmas.djFailedCount ==0){
          if(this.reportParmas.assistCount == 0 && this.reportParmas.otherFailedCount == 0){
            Toast('报工相关数量不能全部为0!');
            return;
          }
          else{
            if(await this.$sysUtil.dialog.showConfirmDialog('确认修改','报工相关数量全部为0，确认提交？') != 'ok') {
              return;
            }
          } 
      }


      if((this.reportParmas.finishCount + this.reportParmas.gFailedCount + this.reportParmas.lFailedCount  + this.reportParmas.djFailedCount +this.reportParmas.otherFailedCount)
        >this.reportParmas.maxAllowCount){
          Toast('不允许超报,请核查!');
            return;
        }


      if(this.isSubmitting){
        return;
      }

      this.isSubmitting = true;

      let selectRecord = this.$refs.xTable.getRadioRecord()
        let selectRecordIndex = this.tableData.findIndex(o=> o.woIndex == selectRecord.woIndex);
        let nextWork = null;

        if(selectRecordIndex < this.tableData.length){
        nextWork = this.tableData[selectRecordIndex+1];
      }


      if(!nextWork &&  (this.reportParmas.store.id == null || this.reportParmas.store.id == '')){
          Toast('仓库不能为空!');
          this.isSubmitting = false;
          return;
        }


      setTimeout(() => {
        

      Toast.loading({
        message: '系统提交中...',
        forbidClick: true,
        duration:0
      });

     

      var postData = {
        ProductId:this.baseInfo.productId,
        Spec:this.baseInfo.spec,
        InputWorkmanship:nextWork?this.reportParmas.nextWorkManShip?.workmanshipId:null,
        InputWorkIndex:nextWork?this.reportParmas.nextWorkManShip?.woIndex:null,
        OutputWorkmanship:selectRecord.workmanshipId,
        OutputWorkIndex:selectRecord.woIndex,
        ProductNo:this.baseInfo.productNo,
        BatchId:this.baseInfo.batchId,
        WoId:selectRecord.woId,
        OutputTarget:selectRecord.departmentId,
        OutputTargetName:selectRecord.department,
        InputTarget:nextWork?this.reportParmas.nextWorkManShip?.departmentId:null,
        InputTargetName:nextWork?this.reportParmas.nextWorkManShip?.department:null,
        Backup:"",
        WorkmanshipName:selectRecord.workmanshipName,
        Producter:store.state.authorize.user.userNo,
        nextWorkManShip:this.reportParmas.nextWorkManShip,
        FinishCount:this.reportParmas.finishCount,
        FailedCount:this.reportParmas.failedCount,
        assistCount:this.reportParmas.assistCount,
        assistTips:this.reportParmas.assistTips,
        gFailedCount:this.reportParmas.gFailedCount,
        lFailedCount:this.reportParmas.lFailedCount,
        djFailedCount:this.reportParmas.djFailedCount,
        otherFailedCount:this.reportParmas.otherFailedCount,
        InStore:this.reportParmas.store.id,
        InStoreName:this.reportParmas.store.name
      }

      var that = this;
      if(nextWork){
        doNotLastWork(postData).then(res=>{
            Toast({
                message: res.message,
                duration:3000
            });

            if(res.code == 200){
              setTimeout(()=>{
                that.loadWoDetail(that.woId);
              },2000);
            }

           this.isSubmitting = false;
           this.reportDialogVisable = false;
        });
      }
      else{
        
        doLastWork(postData).then(res=>{
          Toast({
                message: res.message,
                duration:3000
            });

            if(res.code == 200){
              setTimeout(()=>{
                that.loadWoDetail(that.woId);
              },2000);
            }

            
            this.isSubmitting = false;
            this.reportDialogVisable = false;
          });
        }
      }, 1000);
    },
    async loadWoDetail(woId){
      Toast.loading({
          message: '数据加载中...',
          forbidClick: true
      });

      this.woId = woId;
     
      let resp = await getSubWoDetail({
        woId:woId
      });

      if(resp&&resp.code == 200){
        this.baseInfo = resp.data.main;
        this.tableData = resp.data.list;
        this.redoTableData =resp.data.redoList;
        this.reportDetailList = resp.data.reportList;
        this.woStatus = resp.data.main.woStatus;
        this.isFeeding = resp.data.isFeeading;
        this.isInRep = resp.data.isInRep;
        this.loadDetail = true;
        this.allowOverReport = resp.data.allowOverReport;
        this.isNextWorkManshipJumpEnable = resp.data.isNextWorkManshipJumpEnable;
        this.submitWorkOrderParamsName = resp.data.submitWorkOrderParamsName;
        this.isUserChecker = resp.data.isUserChecker;

        for(var i = 0;i<this.reportDetailList.length;i++){
          if(this.reportDetailList[i].images && this.reportDetailList[i].images != ''){
            var list = this.reportDetailList[i].images.split(',');
            var imgs = [];
            for(var j=0;j<list.length;j++){
              if(list[j]!=''&&list[j]!=',')
                imgs.push("/File" + list[j]);
            }

            this.reportDetailList[i].images = imgs;
          }
        }

      //算出最后一道工序
        var lastFinishCount = this.tableData[this.tableData.length-1].finishCount;

        if(store.state.app.sysConfig.enableBatchManagement && lastFinishCount >0){
          this.isBatchCompleted = true;
        }

        this.$nextTick(o=>{
          Toast.clear();
          var ds = document.getElementsByClassName("vxe-table--body-wrapper");
          setTimeout(()=>{
            let count = 0;
            for(var i=0;i<this.tableData.length;i++){
              console.log(this.tableData[i]['productor'])
              if(this.tableData[i]['productor']&&this.tableData[i]['productor']!=''){
                count = i;
              }
            }
            
            ds[0].scrollTop = count*40;
          },200);
        });

        this.$forceUpdate();
      }
    },
    showReportListDialog(){
      var r = this.$refs.xTable.getRadioRecord(); 

      if(!r){
        Toast('请选择一道工序!');
        return;
      }
     
      this.selectedReportDetailList  = [];
      let selectRecord = this.$refs.xTable.getRadioRecord()
      if(selectRecord){
        this.selectedReportDetailList = this.reportDetailList.filter(o=> o.woIndex == selectRecord.woIndex);
      }
      this.redoDialogVisable = true;
    },
     formateBack(val)  {
                val = val.replace(",,,", "").replace(",,", ",");
                if (val.length > 0 && val[val.length - 1] == ",") {
                    val = val.substr(0, val.length - 1);
                }
                return val;
    },
    //返工
    redo(report){
      Toast.loading({
        message: '系统提交中...',
        forbidClick: true,
        duration:0
      });

      let selectRecord = report;
      let that = this;

      redo(selectRecord.transfOrderId,selectRecord.workmanshipName).then(res=>{
        Toast.clear();

         if(res.code != 200){
            Toast({
              message: res.message,
              duration:3000
            });
         }
         else{
            that.loadWoDetail(that.woId);

       
            Toast({
              message: res.message,
              duration:3000
            });

            that.redoDialogVisable = false;
         }
         
      });
    },
    changeRadio(){
      let selectRecord = this.$refs.xTable.getRadioRecord();
      
      if(selectRecord){  
        if( this.departmentId != selectRecord.departmentId){
          this.isFinishVisable = false;
          this.isRedoVisable = false;
          return;
        }
        this.isFinishVisable = !selectRecord.transfOrderId;

        if(store.state.authorize.user.userNo == selectRecord.productorNo){
          this.isRedoVisable = true;
        }
        else{
          this.isRedoVisable = false;
        }
      }
    },
    open(data){
        //如果是批号管理,扫出来的是批号
      var id = null;
       
      if(store.state.app.sysConfig.enableBatchManagement&&store.state.app.sysConfig.isQrCodeOpen)
      {
          var url = window.location;

          if(data.indexOf(`${url.protocol}//${url.host}/#/productInfo`)>=0){
            data = data.toString().replace('/#/','/')
            id = (new URL(data)).searchParams.get('batchId'); 
          }
          else if(data.indexOf(`${url.protocol}//${url.host}/productInfo`)>=0){
            id =  (new URL(data)).searchParams.get('productId'); 
          }
          else{
            Toast('二维码格式不正确！');
            return;
          }
      }
      else{
        id = data;
      }

      this.loadDetail = false;
      this.curDate = "",
      this.curTime = "",
      this.curWeekDay = cnNumberArray[new Date().getDay()],
      this.scanData = null,
      this.allAlign = 'center',
      this.woId = null,
      this.woStatus=null,
      this.tableData= [],
      this.redoTableData=[],
      this.reportDetailList=[],
      this.selectedReportDetailList=[],
      this.title='MES助手',
      this.baseInfo=null,
      this.startTime=null,
      this.finishTime=null,
      this.isFeeding=false,
      this.qrInfo=null,
      this.resp='',
      this.isInRep=false,
      this.isFinishVisable=false,
      this.isRedoVisable=false,
      this.isSubmitting=false,
      this.activeList=0,
      this.redoDialogVisable=false,
      this.reportParmas = {
        failedCount:0,
        finishCount:0,
        nextWorkManShip:null,
        assistCount:0,
        assistTips:'',
        gFailedCount:0,
        lFailedCount:0,
        djFailedCount:0,
        store:{
          id:null,
          name:null
        }
      },
      this.reportDialogVisable = false
      this.allowOverReport = true;

      this.loadWoDetail(id);
    },
    goToList(){
      this.$emit('goToList');
    },
    viewFileAttacth(){
      getProductsAttachList(this.baseInfo.productNo).then(res=>{
        this.productAttachList = res.data;
        this.attachFilesDialogVisable = true;
      });

      
    },
    audit(row){
      row.isAudit = "T";
      
      auditReport(row.transfOrderId).then(res=>{
        Toast(res.message);
        
        this.loadWoDetail(this.woId).then(res=>{
          this.$forceupdate();
        });
      });
    }, 
    //填报质检结果
    cancelCheckReport(data,index){

    },
    finishCheckReport(data,index){
      finishReportCheck(data.woId,data.transfOrderId,data.checkFailedCount,data.checkDescription).then(res=>{
        Toast(res.message);

        data.beginReportCheck = false;
        
        this.$forceUpdate();
      });

     
    },
    async checkPhoto(reportData){
      var scanResult = await this.$sysUtil.photo();

      if(await this.$sysUtil.dialog.showConfirmDialog('质检图片上传','确定要上传质检图片吗？') != 'ok') {
        return;
      }

      Toast.loading({
          message: '图片上传中...',
          forbidClick: true,
          duration:0
      });

      let selectRecord = this.$refs.xTable.getRadioRecord()
      let nextWork = null;
      let selectRecordIndex = this.tableData.findIndex(o=> o.woIndex == selectRecord.woIndex);
      if(selectRecordIndex < this.tableData.length){
        nextWork = this.tableData[selectRecordIndex+1];
      }

      
      uploadCheckImages(reportData.transfOrderId,scanResult,nextWork == null).then(res=>{
        Toast.clear();
        Toast({
            message: res.message,
            duration:3000
        });

        if(res.data.uploadImagesFilePath){
            var list = res.data.uploadImagesFilePath.split(',');
            var imgs = [];
            for(var j=0;j<list.length;j++){
              if(list[j]!=''&&list[j]!=',')
                imgs.push("/File" + list[j]);
            }

            reportData.images = imgs;
        }

        this.$forceupdate();
      });
    },
    download(attach){
      getProductAttach(attach.key1,attach.key2,attach.key3,attach.key4).then(res=>{

        /*
        const disposition = res.headers["content-disposition"];
        var  fileName = decodeURIComponent(disposition.split("filename*=")[1]);
        fileName = fileName.replace("UTF-8''",""); 

        const url = window.URL.createObjectURL(new Blob([res.data], {type: "application/octet-stream"}))
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
         // const fileName = '1' + '.' + 'pdf'
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          */
          window.open('/File/'+ res.data);
      })
    }
  }
};
</script>

<style scoped>

</style>

<style lang="less">
  .overReport{
  background-color:#88a2bd !important;
  color:white
}
.notOverReport{
  color:black !important
}

</style>

<style lang="less" scoped>

.clientImages{
  width: 100%;
  height: 64px;
  display: inline-block;
    background-repeat: no-repeat;
  background-image: url('/images/2.png');
  background-size:100% 100%;
}

h3 {
  margin:4px;
  font-family: 'Microsoft YaHei';
  font-size: 14px;
  color:rgba(0,0,0,0.4);
}

.baseInfo{
  margin-top:10px;
    padding:0 3px;
}

.baseInfo table{ background:#b1a5a5} 
.baseInfo table td{ background:#FFF} 


/* 
css注释：设置table背景为红色，td背景为白色 */ 
.baseInfo .table,.baseInfo table{
	width:100;
	text-align: center;
	margin:10px 0;
}

.baseInfo  .content{
	color:#1989fa;
  min-width: 60px;
  font-size: 11px;
}

.baseInfo  .title{
	color:rgb(96,98,102);
	font-size:12px;
	font-weight: 700;
	font-family: 'emoji';
  min-width: 60px;
}

table{table-layout: fixed;}

td{word-break: break-all; word-wrap:break-word;}

tr,td{
  line-height: 20px;
}

.list{
  margin-top:12px;
  padding:0 10px;
}

.homePage{
  padding:5px 0;
}

.title {
  text-align: center;
  margin: 16px;
  font-size: 18px;
  font-family: 'SimHei';
}

.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*滚动条的轨道*/ 
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #FFFFFF;
}

/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #F1F1F1;
  box-shadow: inset 0 0 6px rgba(0,0,0,.3);
}
.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #A8A8A8;
}
.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}
/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #FFFFFF;
}
</style>

<style lang="less" scoped>
.goods {
  padding-bottom: 50px;

  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 15px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 14px;
    padding: 5px 10px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}

.detailTitle{
    display: inline-block;
    color:#4d4e51  !important;
    font-size: 14px;
    margin-right: 2px;
    width:64px;
    text-align-last: justify;
    font-weight: 700;
    float:left;
  }
  .detailContent{
    display: inline-block;
    color:black;
    font-size: 12px;
    width:calc(100% - 80px);
    font-weight: 300;
    float:left;
  }

</style>

<style lang="less" scoped>
.van-field__label{
  color:#646566  !important
}

.wrapper div { margin-top:2px;}
.wrapper1 div { margin-top:8px;}

.reportDetailTitle{
  display: inline-block;
  color:#5f5c5c !important;
  font-size: 15px;
  margin-right: 2px;
  font-weight: 700;
  width:80px;
  text-align-last: justify;
  float:left;
}
.reportDetailContent{
  display: inline-block;
  color:#433b3b;
  font-size: 14px;
  font-weight: 300;
  width:calc(100% - 90px);
  float:left;
}

.imageFullScring{
  width:100%;
  height:auto
}

.imageNormal{
  width:240px;
  height:auto;
}
</style>
